/** Session guards for talent feedback — must match `src/app/talentFeedbackSession.js` keys (T2-6218). */

const SUPPRESS_HOME_UNTIL_KEY = 'ts_talent_feedback_suppress_home_until';
const IN_QUEUE_KEY = 'ts_talent_feedback_in_queue';
const PROMPTED_JOB_IDS_KEY = 'ts_talent_feedback_prompted_job_ids';
const SUPPRESS_MS = 3 * 60 * 1000;

function getPromptedJobIds(): number[] {
  try {
    const parsed = JSON.parse(sessionStorage.getItem(PROMPTED_JOB_IDS_KEY) || '[]');
    return Array.isArray(parsed)
      ? parsed.map(Number).filter((id) => Number.isFinite(id) && id > 0)
      : [];
  } catch {
    return [];
  }
}

export function markTalentFeedbackHomePromptSuppressed(): void {
  try {
    sessionStorage.setItem(SUPPRESS_HOME_UNTIL_KEY, String(Date.now() + SUPPRESS_MS));
  } catch { /* ignore */ }
}

export function shouldSuppressTalentFeedbackHomePrompt(): boolean {
  try {
    if (sessionStorage.getItem(IN_QUEUE_KEY) === '1') {
      return true;
    }
    const until = Number(sessionStorage.getItem(SUPPRESS_HOME_UNTIL_KEY) || 0);
    return Date.now() < until;
  } catch {
    return false;
  }
}

export function setTalentFeedbackInQueue(active: boolean): void {
  try {
    if (active) {
      sessionStorage.setItem(IN_QUEUE_KEY, '1');
    } else {
      sessionStorage.removeItem(IN_QUEUE_KEY);
    }
  } catch { /* ignore */ }
}

export function markTalentFeedbackHomePromptShown(jobId: number | string): void {
  const id = Number(jobId);
  if (!Number.isFinite(id) || id <= 0) {
    return;
  }
  try {
    const prompted = getPromptedJobIds();
    if (!prompted.includes(id)) {
      sessionStorage.setItem(PROMPTED_JOB_IDS_KEY, JSON.stringify([...prompted, id]));
    }
  } catch { /* ignore */ }
}

export function shouldAutoPromptTalentFeedbackJob(jobId: number | string): boolean {
  const id = Number(jobId);
  if (!Number.isFinite(id) || id <= 0 || shouldSuppressTalentFeedbackHomePrompt()) {
    return false;
  }
  return !getPromptedJobIds().includes(id);
}
